import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import Radium from 'radium';
import { colors } from 'z-react-components';

import FullWidthRow from '../FullWidthRow';

export const styles = {
    rowStyle: {
        paddingTop: 40,
        paddingBottom: 40,
        marginLeft: 0,
        marginRight: 0
    },
    VideoStyle: {
        maxWidth: 1200,
        float: 'none',
        margin: '0 auto'
    },
    boxTextFormat: {
        fontSize: 18,
        fontWeight: 300,
        top: '30%',
        lineHeight: '20px',
        paddingBottom: 30,
        paddingTop: 80,
        '@media(max-width: 767px)': {
            paddingTop: 10,
            paddingBottom: 60
        },
        '@media(min-width: 768px) and (max-width: 939px)': {
            paddingTop: 40,
            paddingBottom: 60
        }
    },
    textSpace: {
        paddingBottom: 25
    },
    textIcon: {
        textAlign: 'center',
        paddingTop: 5
    },
    boxVideo: {
        height: 370
    }
};

export class VideoBase extends Component {
    render() {
        return (
            <FullWidthRow backgroundColor={colors.white} style={styles.rowStyle}>
                <Col sm={12} style={styles.VideoStyle}>
                    <Col sm={5} xs={12}>
                        <div style={styles.boxTextFormat}>
                            <Col sm={12}>
                                <Col sm={2} xs={2} style={styles.textIcon}>
                                    <img alt="note_checked_icon" src="./_assets/images/note_checked.svg" />
                                </Col>
                                <Col sm={10} xs={10} style={styles.textSpace}>
                                    {"Scegli l'argomento e cerca gli esercizi nell'archivio di CreaVerifiche."}
                                </Col>
                            </Col>
                            <Col sm={12}>
                                <Col sm={2} xs={2} style={styles.textIcon}>
                                    <img alt="note_text_icon" src="./_assets/images/note_text.svg" />
                                </Col>
                                <Col sm={10} xs={10} style={styles.textSpace}>
                                    {'Selezionali e mettili nel carrello. Puoi modificarli o aggiungerne di nuovi.'}
                                </Col>
                            </Col>
                            <Col sm={12}>
                                <Col sm={2} xs={2} style={styles.textIcon}>
                                    <img alt="note_list_icon" src="./_assets/images/note_list.svg" />
                                </Col>
                                <Col sm={10} xs={10} style={styles.textSpace}>
                                    {'Crea la tua verifica ed esportala in word, già organizzata per file diverse.'}
                                </Col>
                            </Col>
                        </div>
                    </Col>
                    <Col sm={7} xs={12}>
                        <iframe
                            style={styles.boxVideo}
                            title="boxVideo"
                            frameBorder="0"
                            height="100%"
                            src={'https://www.youtube-nocookie.com/embed/GowPDEJ7qAE?rel=0'}
                            width="100%"
                        />
                    </Col>
                </Col>
            </FullWidthRow>
        );
    }
}

export default Radium(VideoBase);
